"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebStorage = void 0;
var tslib_1 = require("tslib");
var TokenStorage_1 = require("./TokenStorage");
/**
 * @ignore
 */
var WebStorage = /** @class */ (function (_super) {
    tslib_1.__extends(WebStorage, _super);
    function WebStorage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WebStorage.isAvailable = function () {
        try {
            // firefox throws an exception if cookies are disabled
            if (typeof localStorage === 'undefined') {
                return false;
            }
            localStorage.setItem('bq_webstorage_test', 'bq');
            localStorage.removeItem('bq_webstorage_test');
            return true;
        }
        catch (e) {
            return false;
        }
    };
    /**
     * Creates a global web storage instance for the given origin
     * A web token storage use the localStorage or sessionStorage to store the origin tokens
     * @param origin
     * @return
     */
    WebStorage.create = function (origin) {
        var temporary = false;
        var token = localStorage.getItem("BAT:".concat(origin));
        if (!token && typeof sessionStorage !== 'undefined') {
            token = sessionStorage.getItem("BAT:".concat(origin));
            temporary = !!token;
        }
        return Promise.resolve(new WebStorage(origin, token, temporary));
    };
    /**
     * @inheritDoc
     */
    WebStorage.prototype.saveToken = function (origin, token, temporary) {
        var webStorage = temporary ? sessionStorage : localStorage;
        if (token) {
            webStorage.setItem("BAT:".concat(origin), token);
        }
        else {
            webStorage.removeItem("BAT:".concat(origin));
        }
    };
    return WebStorage;
}(TokenStorage_1.TokenStorage));
exports.WebStorage = WebStorage;
if (WebStorage.isAvailable()) {
    TokenStorage_1.TokenStorage.WEB_STORAGE = WebStorage;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiV2ViU3RvcmFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIldlYlN0b3JhZ2UudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztBQUFBLCtDQUE4QztBQUU5Qzs7R0FFRztBQUNIO0lBQWdDLHNDQUFZO0lBQTVDOztJQTZDQSxDQUFDO0lBNUNRLHNCQUFXLEdBQWxCO1FBQ0UsSUFBSTtZQUNGLHNEQUFzRDtZQUN0RCxJQUFJLE9BQU8sWUFBWSxLQUFLLFdBQVcsRUFBRTtnQkFDdkMsT0FBTyxLQUFLLENBQUM7YUFDZDtZQUVELFlBQVksQ0FBQyxPQUFPLENBQUMsb0JBQW9CLEVBQUUsSUFBSSxDQUFDLENBQUM7WUFDakQsWUFBWSxDQUFDLFVBQVUsQ0FBQyxvQkFBb0IsQ0FBQyxDQUFDO1lBQzlDLE9BQU8sSUFBSSxDQUFDO1NBQ2I7UUFBQyxPQUFPLENBQUMsRUFBRTtZQUNWLE9BQU8sS0FBSyxDQUFDO1NBQ2Q7SUFDSCxDQUFDO0lBRUQ7Ozs7O09BS0c7SUFDSSxpQkFBTSxHQUFiLFVBQWMsTUFBYztRQUMxQixJQUFJLFNBQVMsR0FBRyxLQUFLLENBQUM7UUFDdEIsSUFBSSxLQUFLLEdBQUcsWUFBWSxDQUFDLE9BQU8sQ0FBQyxjQUFPLE1BQU0sQ0FBRSxDQUFDLENBQUM7UUFFbEQsSUFBSSxDQUFDLEtBQUssSUFBSSxPQUFPLGNBQWMsS0FBSyxXQUFXLEVBQUU7WUFDbkQsS0FBSyxHQUFHLGNBQWMsQ0FBQyxPQUFPLENBQUMsY0FBTyxNQUFNLENBQUUsQ0FBQyxDQUFDO1lBQ2hELFNBQVMsR0FBRyxDQUFDLENBQUMsS0FBSyxDQUFDO1NBQ3JCO1FBRUQsT0FBTyxPQUFPLENBQUMsT0FBTyxDQUFDLElBQUksVUFBVSxDQUFDLE1BQU0sRUFBRSxLQUFLLEVBQUUsU0FBUyxDQUFDLENBQUMsQ0FBQztJQUNuRSxDQUFDO0lBRUQ7O09BRUc7SUFDSCw4QkFBUyxHQUFULFVBQVUsTUFBYyxFQUFFLEtBQW9CLEVBQUUsU0FBa0I7UUFDaEUsSUFBTSxVQUFVLEdBQUcsU0FBUyxDQUFDLENBQUMsQ0FBQyxjQUFjLENBQUMsQ0FBQyxDQUFDLFlBQVksQ0FBQztRQUM3RCxJQUFJLEtBQUssRUFBRTtZQUNULFVBQVUsQ0FBQyxPQUFPLENBQUMsY0FBTyxNQUFNLENBQUUsRUFBRSxLQUFLLENBQUMsQ0FBQztTQUM1QzthQUFNO1lBQ0wsVUFBVSxDQUFDLFVBQVUsQ0FBQyxjQUFPLE1BQU0sQ0FBRSxDQUFDLENBQUM7U0FDeEM7SUFDSCxDQUFDO0lBQ0gsaUJBQUM7QUFBRCxDQUFDLEFBN0NELENBQWdDLDJCQUFZLEdBNkMzQztBQTdDWSxnQ0FBVTtBQStDdkIsSUFBSSxVQUFVLENBQUMsV0FBVyxFQUFFLEVBQUU7SUFDNUIsMkJBQVksQ0FBQyxXQUFXLEdBQUcsVUFBVSxDQUFDO0NBQ3ZDIn0=